import { PermissionLevel } from '@/utils/permission';
export const pricingRoutes = [
  {
    component: () => import('@/pages/pricing/EditPrices.vue'),
    meta: {
      permissions: [{ PriceListItemPrice: PermissionLevel.Read }],
      title: 'menu_admin_pricing'
    },
    name: 'EditPrices',
    path: 'edit-prices'
  },
  {
    component: () => import('@/pages/pricing/EditMatrixPrices.vue'),
    meta: {
      permissions: [{ PriceListItemPrice: PermissionLevel.Read }],
      title: 'menu_matrix_prices'
    },
    name: 'EditMatrixPrices',
    path: 'edit-matrix-prices'
  }
];
